export const allocatedTimeOptions = [
  { label: 'Over a week', id: 7 },
  { label: 'Over 3 days', id: 3 },
  { label: 'Over 2 days', id: 2 },
  { label: 'Over 1 day', id: 1 },
  { label: 'Within 24hours', id: 0 },
]
